module.exports = __webpack_public_path__ + "assets/images/payspace-not-found@2x.4d0f02d306f83b782290bfbfba4abaed.webp";